import React from 'react';
import Styled from 'styled';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client';

import defaultStyles from './image-tag-slugs.scss';
import tagSlugsQuery, { ImageTagSlugsQuery, ImageTagSlugsQueryVariables } from './image-tag-slugs.graphql';

interface Props {
    id: string;
    styles: typeof defaultStyles;
}

const ImageTagSlugs: React.FC<Props> = props => {
    const { id, styles } = props;
    const { data } = useQuery<ImageTagSlugsQuery, ImageTagSlugsQueryVariables>(tagSlugsQuery, {
        variables: { imageId: id },
        fetchPolicy: 'cache-first',
    });

    return data?.imageTagSlugs?.edges.length ? (
        <div className={styles.wrapper}>
            <div className={styles.tagSlugTitle}>
                <FormattedMessage id='IMAGE_TAG_SLUGS' />{' '}
            </div>
            <div>
                {data.imageTagSlugs.edges.map(edge => (
                    <React.Fragment key={edge?.node?.id}>
                        <Link className={styles.tagSlug} to={`/inspirations/${edge?.node?.slug}/`}>
                            {edge?.node?.tag.name}
                        </Link>
                        <div className={styles.tagSlugDivider} />
                    </React.Fragment>
                ))}
            </div>
        </div>
    ) : null;
};

export default Styled(defaultStyles)(ImageTagSlugs);
